import { render, staticRenderFns } from "./PersonnelWorklogs.vue?vue&type=template&id=83cf47de&scoped=true"
import script from "./PersonnelWorklogs.vue?vue&type=script&lang=js"
export * from "./PersonnelWorklogs.vue?vue&type=script&lang=js"
import style0 from "./PersonnelWorklogs.vue?vue&type=style&index=0&id=83cf47de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf47de",
  null
  
)

export default component.exports